export default __webpack_public_path__ + "static/media/android_active.40ca8c74.png";